const video = document.querySelector('.product-details__video');
const playButton = document.querySelector('.product-details__video-play');
const videoWrapper = document.querySelector('.product-details__video-wrapper');

function togglePlay() {
  if (video.paused || video.ended) {
    video.play();
    videoWrapper.classList.add('playing');
  } else {
    video.pause();
    videoWrapper.classList.remove('playing');
  }
}

videoWrapper.addEventListener('click', togglePlay);